var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      attrs: { data: _vm.LogData, "cell-class-name": "logcell", height: "200" },
    },
    [
      _c("el-table-column", {
        attrs: {
          width: "180",
          label: _vm.$t("Cuona.Device.header01"),
          prop: "datetime",
        },
      }),
      _c("el-table-column", {
        attrs: {
          width: "100",
          label: _vm.$t("Cuona.Device.header02"),
          prop: "type",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "el-tag",
                  {
                    attrs: {
                      type: _vm.checkType(scope.row.type),
                      size: "mini",
                    },
                  },
                  [_vm._v(_vm._s(scope.row.type))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: _vm.$t("Cuona.Device.header03"), prop: "event" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }